<template>
    <div>
        <div class="container">
            <el-row class="deviceStati">
                <el-col :span="6" class="list defaultCur">
                    <el-card class="box-card">
                        <div class="cardContent">
                            <div class="left">
                                <i class="statiFont iconfont icon--shebei one"></i>
                            </div>
                            <div class="right">
                                <div class="text">设备总数</div>
                                <div class="number">当前拥有的设备数量</div>
                            </div>
                            <div class="rightEnd">{{ allDevice.length }}</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6" class="list" @click.native="openDialog('alarm')">
                    <el-card class="box-card">
                        <div class="cardContent">
                            <div class="left">
                                <i class="statiFont iconfont icon-gbaojings two"></i>
                            </div>
                            <div class="right">
                                <div class="text">报警设备</div>
                                <div class="number">设备发生报警</div>
                            </div>
                            <div class="rightEnd">{{ alarmDevice.length }}</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6" class="list" @click.native="openDialog('maintain')">
                    <el-card class="box-card">
                        <div class="cardContent">
                            <div class="left">
                                <i class="statiFont iconfont icon-weihu three"></i>
                            </div>
                            <div class="right">
                                <div class="text">维护设备</div>
                                <div class="number">设备已经加入维护</div>
                            </div>
                            <div class="rightEnd">{{ maintainDevice.length }}</div>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="6" class="list" @click.native="openDialog('trouble')">
                    <el-card class="box-card">
                        <div class="cardContent">
                            <div class="left">
                                <i class="statiFont iconfont icon-guzhangzhuangtai four"></i>
                            </div>
                            <div class="right">
                                <div class="text">离线设备</div>
                                <div class="number">设备超时未上线</div>
                            </div>
                            <div class="rightEnd">{{ troubleDevice.length }}</div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <el-row class="deviceMap">
                <el-col :span="8" class="list">
                    <!-- <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>设备列表</span>
                        </div>
                        <div class="cardContent">
                            <el-tree
                                :highlight-current="true"
                                :accordion="true"
                                :data="deviceListTree"
                                :props="defaultProps"
                                @node-click="handleNodeClick"
                                :default-checked-keys="deviceListTreeDefault"
                                :node-key="id"
                            ></el-tree>
                        </div>
                    </el-card> -->

                    <mscard class="projcetCard">
                        <template v-slot:header>
                            <div class="cardTitle">项目列表</div>
                        </template>
                        <template v-slot:body>
                            <table class="projectStyle" cellspacing="0">
                                <tr class="projectHeader">
                                    <th>项目名称</th>
                                    <th>项目ID</th>
                                    <th>设备类型</th>
                                    <th>设备数量</th>
                                </tr>
                                <tr @click="handleNodeClick(item, index)"
                                    :class="index == selectProject ? 'projectBody selcetBgc' : 'projectBody'"
                                    v-for="(item, index) in deviceListTree" :key="index">
                                    <td>{{ item.projectName }}</td>
                                    <td>{{ item.projectId }}</td>
                                    <td>{{ item.deviceType }}</td>
                                    <td>{{ item.children.length }}</td>
                                </tr>
                            </table>
                        </template>
                    </mscard>
                </el-col>
                <el-col :span="16" class="list">
                    <mscard class="projcetCard">
                        <template v-slot:header>
                            <div class="cardTitle">设备列表 - {{ deviceListData[0].projectId }}</div>
                        </template>
                        <template v-slot:body>
                            <table class="projectStyle" cellspacing="0">
                                <tr class="projectHeader" style="text-align: center">
                                    <th>设备名称</th>
                                    <th>设备别名</th>
                                    <th>报警状态</th>
                                    <th>维护状态</th>
                                    <th>故障状态</th>
                                    <th>创建时间</th>
                                    <th>更新时间</th>
                                    <th>操作</th>
                                </tr>
                                <tr @click="deviceProp(item, index)" v-for="(item, index) in deviceListData"
                                    :key="index"
                                    :class="selectDevice == index ? 'projectBody selcetBgc' : 'projectBody'"
                                    style="text-align: center">
                                    <td>{{ item.deviceName }}</td>
                                    <td>{{ item.anotherName ? item.anotherName : '未设置' }}</td>
                                    <td
                                        :class="item.alarmStatus ? 'iconfont icon-cuocha_kuai red' : 'iconfont icon-duigou_kuai green'">
                                    </td>
                                    <td
                                        :class="item.maintain == '1' ? 'iconfont icon-cuocha_kuai red' : 'iconfont icon-duigou_kuai green'">
                                    </td>
                                    <td
                                        :class="item.trouble == '1' ? 'iconfont icon-cuocha_kuai red' : 'iconfont icon-duigou_kuai green'">
                                    </td>
                                    <td>{{ item.createtime }}</td>
                                    <td>{{ item.updatetime }}</td>
                                    <td class="moreDeviceDetail" @click="goDeviceDetail(item)">更多操作</td>
                                </tr>
                            </table>
                        </template>
                    </mscard>
                </el-col>
                <!-- <el-col :span="8" class="list">
                    <mscard>
                        <template v-slot:header>设备列表</template>
                        <template v-slot:body>设备列表</template>
                    </mscard>
                </el-col> -->
                <!-- <el-col :span="12" class="list">
                    <el-card class="box-card mapxx">
                        <div slot="header" class="clearfix">
                            <span>地图信息</span>
                        </div>
                        <div class="cardContent">
                            <div class="mapBox" id="mapContainer"></div>
                        </div>
                    </el-card>
                </el-col> -->
                <!-- <el-col :span="16" class="list">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>设备信息</span>
                            <el-button style="float: right; padding: 3px 0" type="text" @click="goDeviceDetail">更多操作</el-button>
                        </div>
                        <div v-if="checkedDevice" class="cardContent">
                            <div class="deviceInfoList">
                                <div class="label">设备名称:</div>
                                <div class="valu">{{ checkedDevice.deviceName }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">设备别名:</div>
                                <div class="valu">{{ checkedDevice.anotherName ? checkedDevice.anotherName : '未设置' }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">设备类型:</div>
                                <div class="valu">{{ checkedDevice.deviceType }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">维护状态:</div>
                                <div class="valu">
                                    <el-tag effect="dark" :type="checkedDevice.maintain == '0' ? 'success' : 'warning'">{{
                                        checkedDevice.maintain == '0' ? '正常' : '维护中'
                                    }}</el-tag>
                                </div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">报警状态:</div>
                                <div class="valu">
                                    <el-tag effect="dark" :type="checkedDevice.alarmStatus == 0 ? 'success' : 'danger'">{{
                                        checkedDevice.alarmStatus == 0 ? '正常' : '报警'
                                    }}</el-tag>
                                </div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">故障状态:</div>
                                <div class="valu">
                                    <el-tag effect="dark" :type="checkedDevice.trouble == '0' ? 'success' : 'info'">{{
                                        checkedDevice.trouble == '0' ? '正常' : '故障'
                                    }}</el-tag>
                                </div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">纬度:</div>
                                <div class="valu">{{ checkedDevice.longitude ? checkedDevice.longitude : '未设置' }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">经度:</div>
                                <div class="valu">{{ checkedDevice.latitude ? checkedDevice.latitude : '未设置' }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">位置:</div>
                                <div class="valu">{{ checkedDevice.location ? checkedDevice.location : '未设置' }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">软件版本:</div>
                                <div class="valu">{{ checkedDevice.software }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">设备创建时间:</div>
                                <div class="valu">{{ checkedDevice.createtime }}</div>
                            </div>
                            <div class="deviceInfoList">
                                <div class="label">数据更新时间:</div>
                                <div class="valu">{{ checkedDevice.updatetime }}</div>
                            </div>
                        </div>
                        <div v-if="!checkedDevice" class="cardContent">
                            <el-empty description="未选中设备"></el-empty>
                        </div>
                    </el-card>
                </el-col> -->
            </el-row>

            <el-row class="propBoxRow">
                <el-col :span="24">
                    <mscard>
                        <template v-slot:header>
                            <div class="cardTitle">设备数据 - {{ propBoxData.deviceName }} - {{ propBoxData.anotherName }}
                            </div>
                        </template>
                        <template v-slot:body>
                            <el-row :gutter="20">
                                <el-col :span="3" v-for="(item, index) in propBoxData.eventPropList" :key="index">
                                    <div class="propBox">
                                        <div class="top">
                                            <img class="img" :src="item.icon" alt="" />
                                        </div>
                                        <div class="mid">{{ item.label }}</div>
                                        <div class="bot">{{ item.value }}</div>
                                    </div>
                                </el-col>
                            </el-row>
                        </template>
                    </mscard>
                </el-col>
                <!-- <el-col :span="24">
                    <el-card>
                        <div slot="header" class="clearfix">
                            <span>监测数据</span>
                        </div>
                        <el-row v-if="checkedDevice" class="propBoxROW" :gutter="3">
                            <el-col :span="3" class="mrl10" v-for="item in eventPropList" :key="item.id">
                                <el-card shadow="hover">
                                    <div class="propCardBoxList">
                                        <div class="text">{{ item.label }}</div>
                                        <div class="value">{{ item.value }}</div>
                                    </div>
                                </el-card>
                            </el-col>
                        </el-row>
                        <div v-if="!checkedDevice" class="propBoxROW">
                            <el-empty description="未选中设备"></el-empty>
                        </div>
                    </el-card>
                </el-col> -->
            </el-row>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
            <el-table :data="dialogTableData">
                <el-table-column property="deviceName" label="设备名称" align="center">
                    <template slot-scope="scope">{{ scope.row.anotherName ? scope.row.anotherName : scope.row.deviceName
                        }}</template>
                </el-table-column>
                <el-table-column property="deviceName" label="设备ID" align="center">
                    <template slot-scope="scope">{{ scope.row.deviceName }}</template>
                </el-table-column>
                <el-table-column property="deviceType" label="设备类型" align="center"></el-table-column>
                <el-table-column property="createtime" label="设备创建时间" align="center"></el-table-column>
                <el-table-column property="updatetime" label="数据更新时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button class="el" type="text" @click="goDeviceDetailRow(scope.row)">更多操作</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import GCJ02_WGS84 from '@/utils/GCJ02_WGS84.js';
import { GetAllDeviceList, QueryProjectName } from '../../api';
import mscard from '@/components/common/dashBoard/msCard.vue';
export default {
    data() {
        return {
            // 底部监测数据
            eventPropList: '',
            id: '',
            // 设备状态弹窗标题
            dialogTitle: '',
            // 设备状态弹窗表格数据
            dialogTableData: [],
            // 统计设备状态是否打开弹窗
            dialogVisible: false,
            // 全部设备
            allDevice: [],
            // 报警设备
            alarmDevice: [],
            // 维护设备
            maintainDevice: [],
            // 故障设备
            troubleDevice: [],
            // 当前选中的设备信息
            checkedDevice: '',
            // 地图DOM
            mapContle: '',
            // 设备信息
            deviceData: [],
            deviceListTree: [],
            deviceListTreeDefault: [0],
            defaultProps: {
                children: 'children',
                label: 'label'
            },

            // 选中项目后右侧的设备列表
            deviceListData: [],
            // 选中设备后的设备数据
            propBoxData: {},
            // 当前点击第几个项目
            selectProject: 0,
            // 当前点击第几个设备
            selectDevice: 0
        };
    },
    created() { },
    mounted() {
        this.getAllDeviceDetail();
        this.changeCardPadding();
    },
    methods: {
        // 销毁地图
        destoryMap() {
            this.mapContle.destroy();
        },
        // 打开设备统计弹窗
        openDialog(e) {
            switch (e) {
                case 'maintain':
                    this.dialogTableData = this.maintainDevice;
                    this.dialogTitle = '维护设备列表';
                    // 维护
                    break;
                case 'alarm':
                    this.dialogTitle = '报警设备列表';
                    this.dialogTableData = this.alarmDevice;
                    // 报警
                    break;
                case 'trouble':
                    this.dialogTitle = '故障设备列表';
                    this.dialogTableData = this.troubleDevice;
                    // 故障
                    break;
                default:
                    break;
            }
            this.dialogVisible = true;
        },
        // 前往设备详情界面
        goDeviceDetail(data) {
            // if (this.checkedDevice == '') {
            //     this.$message.warning('未选中设备');
            //     return;
            // }
            // console.log(this.checkedDevice);
            // switch (this.checkedDevice.deviceType) {
            //     case '智能井盖':
            //         this.$router.push(`ADeviceDetail?projectId=${this.checkedDevice.projectId}&deviceId=${this.checkedDevice.sId}`);
            //         break;
            //     case '水位流速监测':
            //         this.$router.push(`ADeviceDetail1?projectId=${this.checkedDevice.projectId}&deviceId=${this.checkedDevice.sId}`);
            //         break;
            //     case '雨量监测':
            //         this.$router.push(`ADeviceDetail2?projectId=${this.checkedDevice.projectId}&deviceId=${this.checkedDevice.sId}`);
            //         break;
            //     case '不锈钢井盖':
            //         this.$router.push(`ADeviceDetail3?projectId=${this.checkedDevice.projectId}&deviceId=${this.checkedDevice.sId}`);
            //         break;

            //     default:
            //         break;
            // }

            console.log(data);
            switch (data.deviceType) {
                case '智能井盖':
                    this.$router.push(`ADeviceDetail?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '水位流速监测':
                    this.$router.push(`ADeviceDetail1?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '雨量监测':
                    this.$router.push(`ADeviceDetail2?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '智能井盖4G':
                    this.$router.push(`ADeviceDetail4?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '积水监测':
                    this.$router.push(`ADeviceDetail5?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '智能井盖L3W':
                    this.$router.push(`ADeviceDetail?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '水质监测':
                    this.$router.push(`ADeviceDetail6?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '雷达水位计':
                    this.$router.push(`ADeviceDetail7?projectId=${data.projectId}&deviceId=${data.sId}`);
                case '不锈钢井盖':
                    this.$router.push(`ADeviceDetail8?projectId=${data.projectId}&deviceId=${data.sId}`);
                case '智能井盖V4':
                    this.$router.push(`ADeviceDetail9?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                default:

                    break;
            }
        },
        // 分类设备弹出窗的跳转设备详情
        goDeviceDetailRow(row) {
            switch (row.deviceType) {
                case '智能井盖':
                    this.$router.push(`ADeviceDetail?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '水位流速监测':
                    this.$router.push(`ADeviceDetail1?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '雨量监测':
                    this.$router.push(`ADeviceDetail2?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '智能井盖4G':
                    this.$router.push(`ADeviceDetail4?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '积水监测':
                    this.$router.push(`ADeviceDetail5?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '智能井盖L3W':
                    this.$router.push(`ADeviceDetail?projectId=${row.projectId}&deviceId=${row.sId}`);
                    break;
                case '水质监测':
                    this.$router.push(`ADeviceDetail6?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                case '雷达水位计':
                    this.$router.push(`ADeviceDetail7?projectId=${data.projectId}&deviceId=${data.sId}`);
                case '不锈钢井盖':
                    this.$router.push(`ADeviceDetail8?projectId=${data.projectId}&deviceId=${data.sId}`);
                case '智能井盖V4':
                    this.$router.push(`ADeviceDetail9?projectId=${data.projectId}&deviceId=${data.sId}`);
                    break;
                default:
                    break;
            }
        },
        // 地图初始化
        BMap() {
            // console.log('构建地图');
            // var map = this.buildMap(
            //     'mapContainer',
            //     this.$store.state.homeMapSetting.Lng * 1,
            //     this.$store.state.homeMapSetting.Lat * 1,
            //     this.$store.state.homeMapSetting.zIndex * 1,
            //     'a625b4f8a2a68848323269086a5f4fef'
            // );
            // console.log(this.$store.state.homeMapSetting);
            // console.log(
            //     this.$store.state.homeMapSetting.Lng * 1,
            //     this.$store.state.homeMapSetting.Lat * 1,
            //     this.$store.state.homeMapSetting.zIndex * 1
            // );

            var map;
            // var zoom = 12;
            map = new T.Map('mapContainer');
            map.centerAndZoom(
                new T.LngLat(this.$store.state.homeMapSetting.Lng * 1, this.$store.state.homeMapSetting.Lat * 1),
                this.$store.state.homeMapSetting.zIndex * 1
            );

            // 添加内置控件
            //创建缩放平移控件对象
            var control = new T.Control.Zoom();
            //添加缩放平移控件
            map.addControl(control);
            //创建比例尺控件对象
            var scale = new T.Control.Scale();
            //添加比例尺控件
            map.addControl(scale);
            //创建对象
            var ctrl = new T.Control.MapType();
            //添加控件
            map.addControl(ctrl);
            // var point = new BMapGL.Point(this.$store.state.homeMapSetting.Lng * 1 ,this.$store.state.homeMapSetting.Lat * 1);
            // map.flyTo(point, this.$store.state.homeMapSetting.zIndex * 1);
            this.mapContle = map;

            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.deviceData);

            // 点聚合
            // this.markerPoly(map);
        },

        // 设置地图marker
        setMapMarker(type, data) {
            let that = this;
            // type == 1 在线状态  type==2报警状态
            let map = this.mapContle;
            console.log(map);
            map.clearOverLays();

            //创建图片对象
            var orangeIcon = new T.Icon({
                iconUrl: require('@/assets/mark2.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var redIcon = new T.Icon({
                iconUrl: require('@/assets/mark3.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var greenIcon = new T.Icon({
                iconUrl: require('@/assets/mark1.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var jinggaiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggair.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var shuiweiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweir.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var yuliangGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangg.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliango.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangr.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            data.forEach((item, index) => {
                let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(item.latitude * 1, item.longitude * 1);
                var latlng = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
                var marker = '';
                let deviceDetailPagePath = '';
                switch (item.deviceType) {
                    case '智能井盖':
                        deviceDetailPagePath = 'ADeviceDetail';
                        break;
                    case '水位流速监测':
                        deviceDetailPagePath = 'ADeviceDetail1';
                        break;
                    case '雨量监测':
                        deviceDetailPagePath = 'ADeviceDetail2';
                        break;
                    case '智能井盖4G':
                        deviceDetailPagePath = 'ADeviceDetail4';
                        break;
                    case '积水监测':
                        deviceDetailPagePath = 'ADeviceDetail5';
                        break;
                    case '智能井盖L3W':
                        deviceDetailPagePath = 'ADeviceDetail';
                        break;
                    case '水质监测':
                        deviceDetailPagePath = 'ADeviceDetail6';
                        break;
                    case '雷达水位计':
                        deviceDetailPagePath = 'ADeviceDetail7';
                        break;
                    case '不锈钢井盖':
                        deviceDetailPagePath = 'ADeviceDetail8';
                        break;
                    case '智能井盖V4':
                        deviceDetailPagePath = 'ADeviceDetail9';
                        break;
                    default:
                        break;
                }

                switch (item.deviceType) {
                    case '智能井盖':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: jinggaiOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: jinggaiRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: jinggaiGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '水位流速监测':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: shuiweiOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: shuiweiRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: shuiweiGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '雨量监测':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: yuliangRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: yuliangGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '智能井盖4G':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: yuliangRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: yuliangGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '智能井盖V4':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: jinggaiRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: jinggaiGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '积水监测':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: yuliangRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: yuliangGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '智能井盖L3W':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: jinggaiRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: jinggaiGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '水质监测':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: yuliangRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: yuliangGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '雷达水位计':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: yuliangRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: yuliangGreenIcon, deviceInfo: item });
                        }
                        break;
                    case '不锈钢井盖':
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: yuliangOrangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: jinggaiRedIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: jinggaiGreenIcon, deviceInfo: item });
                        }
                        break;
                    default:
                        if (item.maintain === '1') {
                            // 维护状态
                            marker = new T.Marker(latlng, { icon: orangeIcon, deviceInfo: item });
                        } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                            // 故障状态
                            marker = new T.Marker(latlng, { icon: redIcon, deviceInfo: item });
                        } else {
                            marker = new T.Marker(latlng, { icon: greenIcon, deviceInfo: item });
                        }
                        break;
                }
                marker.addEventListener('click', function (e) {
                    that.handleNodeClick({ id: e.target.options.deviceInfo.deviceName, label: e.target.options.deviceInfo.anotherName });
                    // marker.openInfoWindow(infoWin1);
                }); // 将标注添加到地图中
                map.addOverLay(marker);
            });
        },
        // 地图点聚合功能
        // markerPoly(map) {
        //     var view = new mapvgl.View({
        //         map: map
        //     });
        //     var clusterLayer = new mapvgl.ClusterLayer({
        //         minSize: 30, // 聚合点显示的最小直径
        //         maxSize: 50, // 聚合点显示的最大直径
        //         clusterRadius: 150, // 聚合范围半径
        //         gradient: { 0: 'blue', 0.5: 'green', 1.0: 'red' }, // 聚合点颜色梯度
        //         maxZoom: 15, // 聚合的最大级别，当地图放大级别高于此值将不再聚合
        //         minZoom: 5, // 聚合的最小级别，当地图放大级别低于此值将不再聚合
        //         // 是否显示文字
        //         showText: true,
        //         // 开始聚合的最少点数，点数多于此值才会被聚合
        //         minPoints: 5,
        //         // 设置文字样式
        //         textOptions: {
        //             fontSize: 12,
        //             color: 'white',
        //             // 格式化数字显示
        //             format: function(count) {
        //                 return count >= 10000 ? Math.round(count / 1000) + 'k' : count >= 1000 ? Math.round(count / 100) / 10 + 'k' : count;
        //             }
        //         },
        //         enablePicked: true
        //     });

        //     view.addLayer(clusterLayer);
        //     clusterLayer.setData(this.markerMapData());
        // },

        // marker地图定位点数据处理
        // markerMapData() {
        //     let data = this.deviceData;
        //     // let data = this.deviceData;
        //     data.forEach((item, index) => {
        //         data[index].geometry = {
        //             type: 'Point',
        //             coordinates: [item.latitude, item.longitude]
        //         };
        //         data[index].properties = {
        //             width: 30,
        //             height: 30
        //         };
        //         // data[index].lat = item.longitude
        //         // data[index].lng = item.latitude

        //         data[index].properties.icon = require('@/assets/coverGreen.png');
        //     });

        //     console.log(data);
        //     data.forEach((item, index) => {
        //         data[index].id = index;
        //     });
        //     return data;
        // },
        // // 构建地图
        // buildMap(dom, lat, lng, zoom, styleId) {
        //     var map = new BMapGL.Map(dom);
        //     var point = new BMapGL.Point(lat, lng);
        //     map.centerAndZoom(point, zoom);
        //     map.enableScrollWheelZoom(true);
        //     return map;
        // },
        // 获取所有设备信息
        async getAllDeviceDetail() {
            console.log(`${moment(new Date().getTime()).format('YYYY-MM-DD hh:mm:ss')}开始获取数据`);

            const result = await GetAllDeviceList({ companyId: JSON.parse(localStorage.getItem('companyInfo')).companyId });
            console.log(`${moment(new Date().getTime()).format('YYYY-MM-DD hh:mm:ss')}获取数据结束`);

            console.log(result);
            if (result.code !== 200) {
                return;
            }
            result.data.forEach((item, index) => {
                result.data[index].sId = item.id;
            });
            let deviceArr = result.data.filter(item => {
                return item.deviceName != 'J8C149912846VK53'
            })



            this.deviceData = deviceArr;

            // 设备列表树形图-开始
            deviceArr.sort((a, b) => {
                return a.projectId - b.projectId;
            });

            let projectIdArr = [];
            deviceArr.forEach((item) => {
                projectIdArr.push(item.projectId);
            });
            projectIdArr = [...new Set(projectIdArr)];
            let deviceListTree = [];
            for (let index = 0; index < projectIdArr.length; index++) {
                console.log(`${moment(new Date().getTime()).format('YYYY-MM-DD hh:mm:ss')}查询名称开始`);
                let result = await QueryProjectName({ projectId: projectIdArr[index] });
                console.log(`${moment(new Date().getTime()).format('YYYY-MM-DD hh:mm:ss')}查询名称结束`);
                if (result.code !== 200) {
                    return;
                }
                console.log(result);
                // deviceListTree.push({ label: `${result.data.projectName}-${result.data.projectId}`, children: [], id: index });
                deviceListTree.push({
                    projectName: result.data.projectName,
                    projectId: result.data.projectId,
                    deviceType: result.data.deviceType,
                    children: []
                });
            }

            deviceListTree.forEach((item, index) => {
                let projectId = item.projectId;
                deviceArr.forEach((ite, ind) => {
                    if (projectId == ite.projectId) {
                        deviceListTree[index].children.push({
                            label: ite.anotherName ? ite.anotherName : ite.deviceName,
                            id: ite.deviceName
                        });
                    }
                });
            });

            // 顶部设备统计列表----- 开始
            // 全部设备
            let allDevice = deviceArr;
            // 报警设备
            let alarmDevice = [];
            // 维护设备
            let maintainDevice = [];
            // 故障设备
            let troubleDevice = [];

            deviceArr.forEach((item, index) => {
                console.log(item.alarmStatus);

                deviceArr[index].createtime = moment(deviceArr[index].createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                deviceArr[index].updatetime = moment(deviceArr[index].updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                // 判断是否报警设备
                if (item.alarmStatus == 1) {
                    alarmDevice.push(item);
                }

                // 判断是否维护设备
                if (item.maintain == '1') {
                    maintainDevice.push(item);
                }
                // 判断是否故障设备
                if (JSON.parse(localStorage.getItem('companyInfo')).companyId == 2) {
                    if (new Date().getTime() - item.updateTime > 259200000 * 100) {
                        troubleDevice.push(item);
                    }
                } else {
                    if (new Date().getTime() - item.updateTime > 259200000) {
                        troubleDevice.push(item);
                    }
                }

            });

            this.allDevice = allDevice;
            this.alarmDevice = alarmDevice;
            this.maintainDevice = maintainDevice;
            this.troubleDevice = troubleDevice;
            console.log(this.allDevice, 'this.allDevice+++++++++++++++++++++++++');

            // 顶部设备统计列表----- 结束

            this.deviceListTree = deviceListTree;
            // 触发初始点击事件
            this.handleNodeClick(deviceListTree[0], 0);
            // 设备列表树形图 -结束

            // 构建地图
            this.BMap();
        },

        // 修改elcard表头间隔
        changeCardPadding() {
            let dom = document.querySelectorAll('.el-card__header');
            for (let index = 0; index < dom.length; index++) {
                dom[index].style = 'padding: 6px 20px;';
            }
        },

        // 点击了设备
        deviceProp(e, index) {
            this.propBoxData = e;
            this.selectDevice = index;
        },

        // 点击了项目 - 传递设备列表属性
        handleNodeClick(data, index) {
            this.selectProject = index;
            let that = this;
            this.deviceListData = data.children;
            this.deviceListData = this.deviceData.filter((item) => {
                return item.projectId == data.projectId;
            });

            // 设置底部监测数据 --开始
            this.deviceListData = this.deviceListData.map((item) => {
                // 判断设备是否超时离线
                if (new Date().getTime() - item.updateTime > 7776000000) {
                    item.trouble = '1';
                } else {
                    item.trouble = '0';
                }
                let eventPropList = [];
                switch (item.deviceType) {
                    case '智能井盖':
                        eventPropList = [
                            {
                                id: 1,
                                label: '开启状态',
                                value: item.openStatus ? '打开' : '关闭',
                                icon: item.openStatus ? require('@/assets/img/打开应用.png') : require('@/assets/img/关闭.png')
                            },
                            { id: 2, label: '井盖倾斜度', value: `${item.TiltValue} °`, icon: require('@/assets/img/倾角传感器.png') },
                            { id: 3, label: '井内光照度', value: `${item.light} lux`, icon: require('@/assets/img/太阳.png') },
                            { id: 4, label: '电池电压', value: `${item.BatteryRemain} V`, icon: require('@/assets/img/电压.png') },
                            { id: 5, label: '物理小区标识', value: `${item.pci}`, icon: require('@/assets/img/88.png') },
                            { id: 6, label: '信号强度', value: `${item.rssi} dbm`, icon: require('@/assets/img/信号.png') },
                            {
                                id: 7,
                                label: '参考信号接收功率',
                                value: `${item.rsrp} dbm`,
                                icon: require('@/assets/img/功率.png')
                            },
                            {
                                id: 8,
                                label: '信号与干扰加噪声比',
                                value: `${item.sinr} db`,
                                icon: require('@/assets/img/对比.png')
                            }
                        ];
                        break;
                    case '水位流速监测':
                        eventPropList = [
                            {
                                id: 1,
                                label: '断面流速',
                                value: `${item.section_speed} m³/s`,
                                icon: require('@/assets/img/水质监测.png')
                            },
                            { id: 2, label: '瞬时流量', value: `${item.flow} m³/s`, icon: require('@/assets/img/water.png') },
                            { id: 3, label: '累计流量', value: `${item.total_flow} m³`, icon: require('@/assets/img/water.png') },
                            { id: 4, label: '管网水位', value: `${item.level1} m`, icon: require('@/assets/img/水库水位.png') },
                            { id: 5, label: '检查井筒水位', value: `${item.level2} m`, icon: require('@/assets/img/水库水位.png') }
                        ];
                        break;
                    case '雨量监测':
                        eventPropList = [
                            { id: 1, label: '累计雨量', value: `${item.allRain} mm`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                            { id: 2, label: '瞬时雨量', value: `${item.momentRain} mm`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                            { id: 3, label: '今日雨量', value: `${item.todayRain} mm`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                            { id: 4, label: '昨日雨量', value: `${item.yesterdayRain} mm`, icon: require('@/assets/img/GIS-TL_接水点.png') }
                        ];
                        break;
                    case '智能井盖4G':
                        eventPropList = [
                            {
                                id: 1,
                                label: '开启状态',
                                value: item.openStatus ? '打开' : '关闭',
                                icon: item.openStatus ? require('@/assets/img/打开应用.png') : require('@/assets/img/关闭.png')
                            },
                            { id: 2, label: '井盖倾斜度', value: `${item.TiltValue} °`, icon: require('@/assets/img/倾角传感器.png') },
                            { id: 3, label: '电池电压', value: `${item.BatteryRemain} V`, icon: require('@/assets/img/电压.png') },
                            { id: 4, label: '信号强度', value: `${item.csqSignal} dbm`, icon: require('@/assets/img/信号.png') },

                        ];
                        break;
                    case '智能井盖V4':
                        eventPropList = [
                            {
                                id: 1,
                                label: '开启状态',
                                value: item.CS ? '打开' : '关闭',
                                icon: item.CS ? require('@/assets/img/打开应用.png') : require('@/assets/img/关闭.png')
                            },
                            { id: 2, label: '井盖倾斜度', value: `${item.TV} °`, icon: require('@/assets/img/倾角传感器.png') },
                            { id: 3, label: '电池电压', value: `${item.BR} V`, icon: require('@/assets/img/电压.png') },
                            { id: 4, label: '信号强度', value: `${item.R} dbm`, icon: require('@/assets/img/信号.png') },

                        ];
                        break;
                    case '积水监测':
                        if (item.projectId == 'SDjsjc') {
                            eventPropList = [
                                { id: 1, label: '水位', value: `${item.waterLevel / 100}`, icon: require('@/assets/img/水库水位.png') },
                            ];
                        } else {
                            eventPropList = [
                                { id: 1, label: '水位', value: `${item.waterLevel}`, icon: require('@/assets/img/水库水位.png') },
                                { id: 2, label: '电池电压', value: `${item.BatteryRemain} V`, icon: require('@/assets/img/电压.png') },
                                { id: 3, label: '信号强度', value: `${item.signal} dbm`, icon: require('@/assets/img/信号.png') },
                            ];
                        }


                        break;
                    case '雷达水位计':
                        eventPropList = [
                            { id: 1, label: '水位', value: `${item.waterLevel}`, icon: require('@/assets/img/水库水位.png') },
                        ];
                        break;
                    case '不锈钢井盖':
                        eventPropList = [
                            { id: 1, label: '锁机状态', value: `${item.openLock ? '关锁' : '开锁'}`, icon: require('@/assets/img/关闭.png') },
                            { id: 2, label: '信号强度', value: `${item.signal}`, icon: require('@/assets/img/信号.png') },
                            { id: 3, label: '电池电压', value: `${item.ADC0} V`, icon: require('@/assets/img/电压.png') },
                        ];
                        break;
                    case '智能井盖L3W':
                        eventPropList = [
                            {
                                id: 1,
                                label: '开启状态',
                                value: item.openStatus ? '打开' : '关闭',
                                icon: item.openStatus ? require('@/assets/img/打开应用.png') : require('@/assets/img/关闭.png')
                            },
                            { id: 2, label: '井盖倾斜度', value: `${item.TiltValue} °`, icon: require('@/assets/img/倾角传感器.png') },
                            { id: 3, label: '井内光照度', value: `${item.light} lux`, icon: require('@/assets/img/太阳.png') },
                            { id: 4, label: '电池电压', value: `${item.BatteryRemain} V`, icon: require('@/assets/img/电压.png') },
                            { id: 5, label: '物理小区标识', value: `${item.pci}`, icon: require('@/assets/img/88.png') },
                            { id: 6, label: '信号强度', value: `${item.rssi} dbm`, icon: require('@/assets/img/信号.png') },
                            {
                                id: 7,
                                label: '参考信号接收功率',
                                value: `${item.rsrp} dbm`,
                                icon: require('@/assets/img/功率.png')
                            },
                            {
                                id: 8,
                                label: '信号与干扰加噪声比',
                                value: `${item.sinr} db`,
                                icon: require('@/assets/img/对比.png')
                            }
                            ,
                            {
                                id: 9,
                                label: '水浸状态',
                                value: `${item.flood_monitoring}`,
                                icon: require('@/assets/img/GIS-TL_接水点.png')
                            }
                        ];
                        break;
                    case '水质监测':
                        if (item.deviceNo == '03A0572AE0N7S40S' || item.deviceNo == '74580F5E532252FK' || item.deviceNo == '79A632Q1R5U20980' || item.deviceNo == '74AP5916045Z8VSP' || item.deviceNo == 'KEPF6F04B2E110HZ' || item.deviceNo == '6VX5H9D513415CM5') {
                            eventPropList = [
                                {
                                    id: 1,
                                    label: 'PH值',
                                    value: `${item.phValue}`,
                                    icon: require('@/assets/img/GIS-TL_接水点.png')
                                },
                                { id: 2, label: '测量水位值', value: `${item.waterValue} m`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                                { id: 2, label: '标准水位值', value: `${item.sWaterValue ? (item.sWaterValue + 'm') : '未计算'}`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                                { id: 4, label: 'EC值', value: `${item.ecValue} uS/cm`, icon: require('@/assets/img/GIS-TL_接水点.png') },

                            ];
                        } else {
                            eventPropList = [
                                {
                                    id: 1,
                                    label: 'PH值',
                                    value: `${item.phValue}`,
                                    icon: require('@/assets/img/GIS-TL_接水点.png')
                                },
                                { id: 2, label: '测量水位值', value: `${item.waterValue} m`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                                { id: 2, label: '标准水位值', value: `${item.sWaterValue ? (item.sWaterValue + 'm') : '未计算'}`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                                { id: 3, label: 'COD值', value: `${item.codValue} mg/L`, icon: require('@/assets/img/GIS-TL_接水点.png') },
                                { id: 4, label: 'EC值', value: `${item.ecValue} uS/cm`, icon: require('@/assets/img/GIS-TL_接水点.png') },

                            ];
                        }

                        break;
                    default:
                        break;
                }
                item.eventPropList = eventPropList;
                return item;
            });

            this.deviceProp(this.deviceListitem[0], 0);
            console.log(this.deviceListData);

            return;

            if (deviceDeatil.latitude == null || deviceDeatil.longitude == null) {
                this.$message.warning('未设置经纬度信息');
                // 判断故障状态  超时三天未上线即为故障

                // 设置底部监测数据 --结束

                that.checkedDevice = deviceDeatil;
                deviceDeatil.createtime = moment(deviceDeatil.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                deviceDeatil.updatetime = moment(deviceDeatil.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
            } else {
                // 已经设置了经纬度信息
                let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(deviceDeatil.latitude * 1, deviceDeatil.longitude * 1);
                var point = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
                this.mapContle.panTo(point, 18);
                // 判断故障状态  超时三天未上线即为故障
                if (new Date().getTime() - deviceDeatil.updateTime > 7776000000) {
                    deviceDeatil.trouble = '1';
                } else {
                    deviceDeatil.trouble = '0';
                }
                deviceDeatil.location = deviceDeatil.county + deviceDeatil.address;
                deviceDeatil.createtime = moment(deviceDeatil.createTime * 1).format('YYYY-MM-DD HH:mm:ss');
                deviceDeatil.updatetime = moment(deviceDeatil.updateTime * 1).format('YYYY-MM-DD HH:mm:ss');
                console.log(deviceDeatil);
                that.checkedDevice = deviceDeatil;

                let eventPropList = [];
                switch (deviceDeatil.deviceType) {
                    case '智能井盖':
                        eventPropList = [
                            {
                                id: 1,
                                label: '开启状态',
                                value: deviceDeatil.openStatus ? '打开' : '关闭'
                            },
                            { id: 2, label: '井盖倾斜度(°)', value: deviceDeatil.TiltValue },
                            { id: 3, label: '井内光照度(lux)', value: deviceDeatil.light },
                            { id: 4, label: '电池电压(V)', value: deviceDeatil.BatteryRemain },
                            { id: 5, label: '物理小区标识', value: deviceDeatil.pci },
                            { id: 6, label: '信号强度(dbm)', value: deviceDeatil.rssi },
                            { id: 7, label: '参考信号接收功率(dbm)', value: deviceDeatil.rsrp },
                            { id: 8, label: '信号与干扰加噪声比(db)', value: deviceDeatil.sinr }
                        ];
                        break;
                    case '水位流速监测':
                        eventPropList = [
                            { id: 1, label: '断面流速(m³/s)', value: deviceDeatil.section_speed },
                            { id: 2, label: '瞬时流量(m³/s)', value: deviceDeatil.flow },
                            { id: 3, label: '累计流量(m³)', value: deviceDeatil.total_flow },
                            { id: 4, label: '管网水位(m)', value: deviceDeatil.level1 },
                            { id: 5, label: '检查井筒水位(m)', value: deviceDeatil.level2 }
                        ];
                        break;
                    case '雨量监测':
                        eventPropList = [
                            { id: 1, label: '累计雨量(mm)', value: deviceDeatil.allRain },
                            { id: 2, label: '瞬时雨量(mm)', value: deviceDeatil.momentRain },
                            { id: 3, label: '今日雨量(mm)', value: deviceDeatil.todayRain },
                            { id: 4, label: '昨日雨量(mm)', value: deviceDeatil.yesterdayRain }
                        ];
                        break;

                    default:
                        break;
                }
                that.eventPropList = eventPropList;
            }
        }
    },
    beforeDestroy() {
        console.log('我要销毁了');
        // this.destoryMap();
    },
    components: {
        mscard
    }
};
</script>

<style scoped lang="less">
@import '../../assets/css/variables.less';

.container {
    background-color: @black-two;
}

// 修改弹窗样式 ---开始--
/deep/ .el-dialog__header {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__title {
    color: #fff;
}

/deep/ .el-dialog__body {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-dialog__footer {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table th {
    background-color: @black-two !important;
    color: @gray-one;
}

/deep/ .el-table tr {
    background-color: @black-two;
    color: #fff;
}

/deep/ .el-table tr:hover {
    background: @black-three !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: none;
}

/deep/ .el-table__empty-block {
    background-color: @black-two;

    border: none;
}

/deep/ .el-table__empty-text {
    color: #fff;
}

/deep/ .el-button--text {
    color: @gray-one;
}

/deep/ .el-button--text:hover {
    color: #fff;
}

/deep/ .el-button--primary {
    background-color: @black-three;
    color: #fff;
    border: none;
    transition: all 0.5s;
}

/deep/ .el-button--primary:hover {
    background-color: #fff;
    color: @black-three;
    border: none;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
    color: #fff;
}

// 修改弹窗样式 ---结束--

.deviceStati {
    .list {
        margin: 0 10px;
        cursor: pointer;
        width: 100%;
    }

    .defaultCur {
        cursor: default;
    }

    display: flex;
    justify-content: space-between;

    .box-card {
        border: none;
        background-color: @black-three;
        border-radius: 20px;

        .cardContent {
            display: flex;
            box-sizing: border-box;
            color: @white-one;
            justify-content: space-between;
            font-size: 16px;
            align-items: center;
            padding: 0 10px;

            .left {
                display: flex;
                align-items: center;
                font-size: 40px;

                .one {
                    color: @primary-color;
                }

                .two {
                    color: @alarm-color;
                }

                .three {
                    color: @maintain-color;
                }

                .four {
                    color: @trouble-color;
                }

                .statiFont {
                    font-size: 40px;
                }
            }

            .right {
                text-align: left;

                .text {
                    font-weight: bold;
                    font-size: 25px;
                }

                .number {
                    margin-top: 5px;
                    font-size: 17px;
                    color: @gray-one;
                }
            }

            .rightEnd {
                font-size: 40px;
                color: @white-one;
                margin-left: 10px;
            }
        }
    }
}

.projcetCard {
    width: 100%;
    min-height: 500px;
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;

    .projectStyle {
        width: 100%;

        tr {
            height: 40px;
            text-align: left;
        }

        .projectHeader {
            font-size: 12px;
            background-color: @gray-two;
            color: @gray-one;
        }

        .projectBody {
            font-size: 14px;
        }

        .projectBody:hover {
            cursor: pointer;
            background-color: @black-two;
        }

        td,
        th {
            padding: 0 10px;
            border: none;
        }
    }
}

.propBoxRow {
    .propBox {
        background-color: @gray-two;
        box-sizing: border-box;
        padding: 5px;
        border-radius: 20px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10px;

        .top {

            .img {
                border-radius: 50%;
                width: 40px;
                height: 40px;
            }
        }

        .mid {
            font-size: 16px;
        }

        .bot {
            font-size: 14px;
            margin-top: 10px;
        }
    }
}

.deviceMap {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;

    .list {
        margin: 0 10px;

        .el-card {
            background-color: @black-three !important;
            border: 0;
            color: @white-one;
        }

        .cardContent {
            height: 350px;
            max-height: 350px;
            overflow: scroll;

            .el-tree {
                background-color: @black-three !important;
                color: @white-one;
            }

            .el-tree-node__content {
                background-color: red !important;
            }
        }

        .cardContent::-webkit-scrollbar {
            width: 0 !important;
            width: 10px;
            height: 10px;
            border-radius: 10px;
            background-color: #f5f5f5;
        }
    }

    .mapBox {
        width: 100%;
        height: 100%;
    }
}

.propbOX {
    margin: 0 10px;
    margin-top: 10px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;

    .propCardBoxList {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;

        .text {
            text-align: center;
            font-weight: bold;
            font-size: 12px;
        }

        .value {
            text-align: center;
            font-size: 16px;
            margin-top: 10px;
        }
    }
}

.deviceInfoList {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    font-size: 14px;

    .label {
        margin-right: 10px;
        font-weight: bold;
    }
}

.selcetBgc {
    background-color: @black-two;
}

.moreDeviceDetail {
    color: @gray-one;
    transition: all .3s;
}

.moreDeviceDetail:hover {
    color: #fff;
}
</style>